import React, { useState } from 'react';
import { addAlert } from '../../actions/alerts.action';
import { useDispatch } from 'react-redux';
import { fetchProjects } from '../../api/project/project.api';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import {
  makeStyles,
  CircularProgress,
  Container,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';

import Header from '../Header/Header';
import List from './List';
import { NAVIGATION_DRAWER_WIDTH } from '../../utils/const';

const useStyles = makeStyles({
  title: {
    color: '#999999',
    fontSize: '16px',
    textTransform: 'uppercase',
    margin: '40px auto 20px auto'
  }
});

const ProjectsPage = () => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const [ drawerOpen, setDrawerOpen ] = useState(false);

  const projectsQuery = useQuery(
    [ 'projects' ],
    async () => {
      const { data } = await fetchProjects();
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const projects = projectsQuery.data;

  return (
    <>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen }/>
      <div style={ {
        marginLeft: !sm ? 'auto' : drawerOpen ? `${NAVIGATION_DRAWER_WIDTH}px` : '55px'
      } }>
        <Container maxWidth='xl'>
          <Typography className={ classes.title }>
            {t('projects.title')}
          </Typography>
          { !projects && <CircularProgress/>}
          { projects && projects.length !== 0 &&
            <List projects={ projects }/>
          }
          {
            projects && projects.length === 0 &&
            t('projects.noProjects')
          }
        </Container>
      </div>
    </>
  );
};

export default ProjectsPage;
